module.exports = __webpack_public_path__ + "static/media/Coltar-Ceramic-Klinker-240X115-X-71-X-10---Alhambra-(HF04).967fb912.jpg";